import React from 'react'; //eslint-disable-line no-unused-vars
import Route from 'react-router/Route';
import Redirect from 'react-router/Redirect';
import Switch from 'react-router/Switch';
import {HomeView, EulaView} from '../views';
import {Error404} from '../components';
import {getPath} from 'epic-common/src/route';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}`;
    return (
        <Redirect to={redirectUrl} />
    );
};
const goHome = redirectLocale.bind(null, '/home');

const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route exact path={`${path}:locale/`} render={goHome} />
            <Route path={`${path}:locale/home`} component={HomeView} />
            <Route path={`${path}:locale/eula`} component={EulaView} />
            <Route component={Error404} />
        </Switch>
    );
    return routes;
};

export default getRoutes;
